export const LOAN_TYPES = [
  {
    value: "HOME_LOAN",
    label: "Home Loan",
  },
  {
    value: "BUSINESS_LOAN",
    label: "Business Loan",
  },
  {
    value: "LOAN_AGAINST_PROPERTY",
    label: "Loan Against Property",
  },
  {
    value: "COMMERCIAL_PURCHASE_LOAN",
    label: "Commercial Purchase Loan",
  },
  {
    value: "MORTGAGE_LOAN",
    label: "Mortgage Loan",
  },
  {
    value: "CONSTRUCTION_LOAN",
    label: "Construction Loan",
  },
  {
    value: "OD_DROPLINE_OD",
    label: "OD / Dropline OD",
  },
  {
    value: "CC_LIMIT",
    label: "CC Limit",
  },
  {
    value: "CAR_LOAN",
    label: "Car Loan",
  },
  {
    value: "PERSONAL_LOAN",
    label: "Personal Loan",
  },
  {
    value: "LRD_PROGRAM",
    label: "LRD Program",
  },
  {
    value: "TAKEOVER_TOPUP",
    label: "Takeover + Top-Up",
  },
  {
    value: "WEALTH_BASED_LOAN",
    label: "Wealth Based Loan",
  },
];

export const LOAN_TYPE_LABELS = Object.fromEntries(
  LOAN_TYPES.map((item) => [item.value, item.label]),
);

export const getLoanTypeLabel = (value) =>
  LOAN_TYPE_LABELS[value] ?? value ?? "—";
